module.exports = __webpack_public_path__ + "static/img/sw.4b835ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/funImg/sw.png
// module id = s174
// module chunks = 1